import {Component, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {AssistanceTicket} from '../../../../models/assistanceticket';
import {AssistanceService} from '../../../../models/assistanceservice';
import {AssistancePlanService} from '../../../../models/assistance-plan-service';
import {AssistanceCategory} from '../../../../models/assistance-category';
import {ApiService} from '../../../../api/api.service';
import { ToastMessageOptions } from 'primeng/api';
import { ConfService } from '../../../../services/conf.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Country } from '../../../../models/country';
import { SelectLocationComponent } from '../../../select-location/select-location.component';

@Component({
    selector: 'app-assistance-tickets-form',
    templateUrl: './assistance-tickets-form.component.html',
    styleUrls: ['./assistance-tickets-form.component.css'],
    standalone: false
})
export class AssistanceTicketsFormComponent implements OnInit {
  @Input() categories: any[] = [];
  @Input() responseChubb: EventEmitter<any>;
  @Input() assistancecase;
  @Input() selectedSale;
  @Input() plan_id;
  @Input() member_id;
  @Input() sale_canceled;
  @Input() parent_form: any = { "invalid": false, "pending": false };
  @Input() caseLocation: any = {};
  @Input() disabled: EventEmitter<boolean>;
  @Input() reset: EventEmitter<void>;
  @Output() update = new EventEmitter<AssistanceTicket>();
  @Output() cancelEvent = new EventEmitter();
  @Input() isDisabled = false;
  @Input() destinationCountry: Country;
  @Input()  states: any[];
  statesDistrict: any[];
  offset: any;
  memberLocation = new EventEmitter<any>();
  showMap = new EventEmitter<boolean>();
  captureLocation = new EventEmitter<boolean>();
  messageFlag : boolean;
  editcategory: AssistanceCategory;
  editservice: AssistanceService;
  additionalplanservice : AssistancePlanService;
  selectCategory_id: number;
  selectBrand_id: number;
  selectModel_id: number;
  services: any[] = [];
  showcarflag = false;
  carbrands: any[] = [];
  carmodels: any[] = [];
  years: number[] = [];
  selectYear: number;
  colors: any[] = [];
  comment = '';
  editticket: AssistanceTicket;
  latitude: any;
  longitude: any;
  iAm = null;
  in_use: number;
  fieldsRequired = {
    'programdate': false
  };
  remaining_assistances: number;
  courtesy_assistances: number;
  inperiod_assistances: number;
  report_time: number;
  used_services: number;
  total_cases: number;
  is_on_waiting_period: boolean;
  messages: ToastMessageOptions[] = [];
  programmed = 0;
  connection = 0;
  pass=true;
  program_type: any;
  triage?:any;
  
  programtime: any;
  assistance_programming_types = [];
  areAmountsVisible: boolean;
  maxAssistancesReached: boolean;

  brandSelected:any;

  gasolineTypes:any[] = [    

    {name: "Magna", id: 1},
    {name: "Premium", id: 2},
    {name: "Diesel", id: 3}

  ]

  consumido: number
  disponible: number
  excedente2: number
  intime = 0

  @ViewChild('selectLocationComp')
  selectLocationComponent: SelectLocationComponent
  ambulance_id = [19,139,155,241,475,518,521,522,526,531,532,619,631,637,133,916]
  stopLightNumber: number = 0;
  
  constructor(private api: ApiService, public conf: ConfService,
    private translate: TranslateService) {
    let loopyear = 1960;
    let last_year = new Date().getUTCFullYear() + 2;
    while (loopyear <= last_year) {
      this.years.push(loopyear);
      loopyear++;
    }
    this.areAmountsVisible = false;

    this.maxAssistancesReached = false;
    this.offset = (new Date().getTimezoneOffset() / 60);
    this.messageFlag = false;
  }



  ngOnInit() {
    this.editticket = new AssistanceTicket();
    this.editcategory = new AssistanceCategory();
    this.editservice = new AssistanceService();
    this.additionalplanservice = new AssistancePlanService();
    this.destinationCountry = new Country();

    // Get programming types
 
    this.api.assistance_programming_types
    .get()
    .promise()
    .then(resp => {
      this.assistance_programming_types = resp;
      this.api.carBrands.getCarColors().promise().then( resp =>
        {
          this.colors = resp;
        });
    }, e => {
      
    })


    if (this.disabled) {
      this.disabled.subscribe(disabled => {
        this.isDisabled = disabled;
      });
    }

    if (this.responseChubb) {
      this.responseChubb.subscribe(resp => {

        if (resp) {

          this.categories = resp.assistancecategories;
          this.onSelectCategory(50);
          this.editticket.car_plate = resp.saleClientSelected["Placas"];
          this.editticket.vehicle_reference = resp.saleClientSelected["DescripcionVehiculo"];
          this.selectYear = parseInt(resp.saleClientSelected["Modelo"]);

          const filter = {
            name: resp.saleClientSelected["Marca"]
          };

          this.api.carBrands.search().filter(filter).promise()
            .then((data) => {
              this.brandSelected = data.data.find(element => element.name == resp.saleClientSelected["Marca"]);
              
              this.onSelectBrand(this.brandSelected, true, resp.saleClientSelected["Tipo"]);
            });

        }


      });
    }

    if (this.reset) {
      this.reset.subscribe(() => {
        this.editticket = new AssistanceTicket();
        this.editcategory = new AssistanceCategory();
        this.editservice = new AssistanceService();
        this.selectCategory_id = null;
        this.editticket.service_id = null;
        this.selectBrand_id = null;
        this.selectModel_id = null;
        this.selectYear = null;
        this.showcarflag = false;
        this.carbrands = [];
        this.carmodels = [];
        this.services = [];
        this.comment = '';
        this.programmed = 0
        this.connection = 0
        this.program_type = null;
        this.triage = null;
        this.selectLocationComponent.resetComponent()

        if (this.sale_canceled) { // set default by connection
          this.connection = 1;
          this.editticket.connection = 1;
        }
        this.resetNums();
      });
    }

   
  }

  resetNums() {
    this.areAmountsVisible = false;
    this.maxAssistancesReached = false;
    this.remaining_assistances = null;
    this.courtesy_assistances = null;
    this.used_services = null;
    this.total_cases = null;
    this.is_on_waiting_period = false;
    this.intime = null
    this.in_use = null
    this.consumido = null
    this.disponible = null
  }

  onCancel() {
    this.selectLocationComponent.resetComponent()
    this.cancelEvent.emit();
  }

  onSelectCategory(category_id) {
    this.resetNums();
    if (category_id) {
        this.selectCategory_id = parseInt(category_id);
        this.editcategory = _.find(this.categories, p => p.id == this.selectCategory_id);

        if (this.assistancecase) {
          if (this.editcategory.name.toLowerCase().indexOf("vial") >= 0) {
            this.showcarflag = true;
            this.api.carBrands.get().all().promise()
              .then(b => {
              this.carbrands = b.data;
              });
            if (this.assistancecase.assistance_sale_id) { // when has sale_id, auto select car
                this.api.assistancesales.getbyId(this.assistancecase.assistance_sale_id).promise()
                  .then(sale => {
                    const case_sale = sale;
                    if (case_sale.assistance_sale_car.length > 0) {
                      const saleCar = case_sale.assistance_sale_car[0];
                      this.selectBrand_id = saleCar.car_model.brand_id;
                      this.carbrands = [saleCar.car_model.brand];
                      this.editticket.brand_description = saleCar.brand_description;
                      this.editticket.model_description = saleCar.model_description;
                      this.editticket.car_model = saleCar.car_model_name;
                      this.carmodels = [saleCar.car_model];
                      this.selectModel_id = saleCar.car_model_id;
                      this.editticket.car_year = case_sale.assistance_sale_car[0].car_year;
                      this.selectYear = case_sale.assistance_sale_car[0].car_year;
                      this.editticket.color_description = saleCar.color_description;
                      this.editticket.car_color_name = saleCar.color_description;
                      this.editticket.car_color = case_sale.assistance_sale_car[0].car_color;
                      this.editticket.car_plate = case_sale.assistance_sale_car[0].car_plate;
                    }
                  })
                  .catch(error =>{
                    
                  });
            }
          } else {
            this.showcarflag = false;
          }
          this.api.assistanceserviceCategoryProduct.get(this.selectCategory_id, this.assistancecase.id).promise()
            .then(s => {
              this.services = s.data;
            });

        } else {
          // No assistance case
          if (this.editcategory.name.toLowerCase().indexOf("vial") >= 0) {
            this.showcarflag = true;
            this.api.carBrands.get().all().promise().then(b => {
              this.carbrands = b.data;
            });
            
            if (this.selectedSale) { // when has sale_id, auto select car
                this.api.assistancesales.getbyId(this.selectedSale.id).promise()
                  .then(sale => {
                    const case_sale = sale;
                    if (case_sale.assistance_sale_car.length > 0) {
                      const saleCar = case_sale.assistance_sale_car[0];
                      this.selectBrand_id = saleCar.car_model.brand_id;
                      this.carbrands = [saleCar.car_model.brand];
                      this.editticket.brand_description = saleCar.brand_description;
                      this.editticket.model_description = saleCar.model_description;
                      this.editticket.car_model = saleCar.car_model_name;
                      this.carmodels = [saleCar.car_model];
                      this.selectModel_id = saleCar.car_model_id;
                      this.editticket.car_year = case_sale.assistance_sale_car[0].car_year;
                      this.selectYear = case_sale.assistance_sale_car[0].car_year;
                      this.editticket.color_description = saleCar.color_description;
                      this.editticket.car_color_name = saleCar.color_description;
                      this.editticket.car_color = case_sale.assistance_sale_car[0].car_color;
                      this.editticket.car_plate = case_sale.assistance_sale_car[0].car_plate;
                    }
                  })
                  .catch(error =>{
                    
                  });
            }
          } else {
            this.showcarflag = false;
          }

          this.api
            .assistanceserviceCategoryProductPlan
            .get(this.selectCategory_id, this.plan_id).promise()
            .then(s => {
              this.services = s.data;
            });
        }


    } else {
      this.services = [];
      this.showcarflag = false;
    }

    this.editticket.service_id = null;
    this.editservice = null;
  }

  onSelectBrand(brand_id, defaultSelect = false, value = "") {
    this.editticket.car_brand = brand_id.name;
    this.editticket.brand_description = brand_id.name;
    this.editticket.model_description = null;
    this.selectModel_id = null;
    if (brand_id) {
      this.api.carBrands.getModels(brand_id.id).all().promise()
        .then(models => {
        this.carmodels = models;


        if(defaultSelect){
          this.selectModel_id = this.carmodels.find(element => element.name == value).id;
        }


        });
    } else {
      this.carmodels = [];
    }
  }

  onSelectModel(model_id) {
    if (model_id) {
      let carmodel = _.find(this.carmodels, p => p.id == model_id);

      if(carmodel){
        this.editticket.model_description = carmodel.name;
        this.editticket.car_model = carmodel.name;
      }

    } else {
      this.editticket.model_description = null;
      this.editticket.car_model = null;
    }
  }

  onSelectYear(year) {
    if (year) {
      this.editticket.car_year = parseInt(year);
    } else {
      this.editticket.car_year = null;
    }
  }

  onSelectColor(color) {
    if (color) {
      this.editticket.color_description = color;
      this.editticket.car_color_name = color;
    } else {
      this.editticket.color_description = null;
      this.editticket.car_color_name = null;
    }
  }

  onSelectService(service_id) {
    // Reset loaded numbers
    this.resetNums();
    if (service_id) {
        this.messages = [];
        this.editservice = _.find(this.services, p => p.id == service_id);
        this.editticket.service_id = parseInt(service_id);

        if (this.assistancecase) {
          this.api.assistanceplanAmount.get(service_id, this.assistancecase.id).promise()
            .then(data => {
              this.areAmountsVisible = true;
              this.remaining_assistances = data.remaining_assistances;
              this.courtesy_assistances = data.courtesy_assistances;
              this.inperiod_assistances = data.inperiod_assistances
              this.intime = data.used_services2
              this.in_use=data.in_use
              
              this.pass=data.pass
              
              
               
              this.used_services = data.used_services;
              this.total_cases = data.total_cases;
              this.is_on_waiting_period = data.on_waiting_period;

              if (this.remaining_assistances !== undefined
                && this.remaining_assistances <= 0) {
                // Only offer by connection
                this.maxAssistancesReached = true;
                this.onSelectConnection(1);
              }
              else if (this.is_on_waiting_period) {
                this.onSelectConnection(1);
              }

            })
            .catch(e => {
              this.translate.get('Unable to get service for sale information')
                .subscribe((res: string) => {
                  this.messages.push({
                    severity: 'error',
                    summary: 'Error',
                    detail: `${res}: ${e.error}`
                  });
                });
              });

        } else {
          this.api.assistanceplanAmount.getByPlan(service_id, this.plan_id, this.selectedSale.id, this.member_id).promise()
            .then(data => {
              this.areAmountsVisible = true;
              this.remaining_assistances = data.remaining_assistances;
              this.used_services = data.used_services;
              this.total_cases = data.total_cases;
              this.courtesy_assistances = data.courtesy_assistances;
              this.is_on_waiting_period = data.on_waiting_period;

              if (this.remaining_assistances !== undefined
                && this.remaining_assistances <= 0) {
                // Only offer by connection
                this.maxAssistancesReached = true;
                this.onSelectConnection(1);
              }
              else if (this.is_on_waiting_period) {
                this.onSelectConnection(1);
              }

            })
            .catch(e => {
              this.translate.get('Unable to get service for sale information')
                .subscribe((res: string) => {
                  this.messages.push({
                    severity: 'error',
                    summary: 'Error',
                    detail: `${res}: ${e.error}`
                  });
                });
              });
        }
        this.extrainfo(service_id)
    } else {
      this.editticket.service_id = null;
      this.editservice = null;
    }
    
  }
  async extrainfo2(idservice,max){
    
    
    
    
    
    
    try{
     
      const filter2 = {'plan_id': this.plan_id,'service_id': idservice,  'total':max};
  
      await( this.api.assistanceplanservices.get_operations12().filter(filter2).promise()
      .then(data =>{
        //this.excedente2 = this.bill.price_billed - data[0]['disponible']
        this.consumido = data[0]['consumido']
        this.disponible = data[0]['disponible']
      }))
      
     } catch(exception){
      
      
      
      
    }
  

  }
  async extrainfo(idservice){
    
    
    

    const filter = {'plan_id': this.plan_id,'service_id': idservice };
    await  this.api.assistanceplanservices.get_extrainfo().filter(filter).promise()
        .then(data => {

          this.additionalplanservice.emergency_reporting_time=data[0].emergency_reporting_time
          this.additionalplanservice.territoriality = data[0].territoriality;
       
          this.additionalplanservice.special_condition=data[0].special_condition
        
          this.additionalplanservice.max_amount_general = data[0].max_amount_general || 0
          

          
                  });
      
    this.extrainfo2(idservice,this.additionalplanservice.max_amount_general)
                  

  }

  onSelectProgram(value) {
    this.programmed = value;
    if (this.programmed === 1) {
      this.editticket.programmed = 1;
    } else
      this.editticket.programmed = null;
    this.fieldsRequired['programdate'] = false;
    this.editticket.programdate = new Date();
    this.programtime = new Date().getHours() + ':' + new Date().getMinutes();
  }

  onSelectday(date) {
    if (date === null) {
      this.fieldsRequired['programdate'] = true;
    } else {
    const set_date = date + ' ' + this.programtime;
      // this.editticket.programdate = new Date(set_date);
      // this.editticket.programdate = moment(set_date).subtract(this.offset, "hours").toDate();
      this.editticket.programdate = moment(set_date).toDate();
      this.fieldsRequired['programdate'] = false;
    }
  }

  onSelectTime() {
    const set_date = this.editticket.programdate.toDateString() + ' ' + this.programtime;
    // this.editticket.programdate = moment(set_date).subtract(this.offset, "hours").toDate();
    this.editticket.programdate = moment(set_date).toDate();
    // this.editticket.programdate = new Date(set_date);

  }

  onSelectConnection(value) {
    this.connection = value;
    this.editticket.connection = value;
  }

  onSelectProgramType(event) {
    let value = event.target.value;
    this.program_type = +value || null;
    this.editticket.program_type = +value || null;
  }

  step1SetLocation(location) {
    this.editticket.latitude = location.latitude;
    this.editticket.longitude = location.longitude;
  }

  step1SelectMap() {
    if (this.assistancecase.country.locale.length > 2) {
      this.assistancecase.country.locale = this.assistancecase.country.locale.split('-')[1].toLowerCase();
    }

    this.showMap.emit(true);

  }

  onSubmit() {
    // this.isDisabled = true;
    this.onSelectYear(this.selectYear)
    this.editticket.ticket_type = 1;
    this.editticket.comment = this.comment;
    
    if (this.editticket.brand_description) {
      this.editticket.car_brand = this.editticket.brand_description;
    }
    if (this.editticket.model_description) {
      this.editticket.car_model = this.editticket.model_description;
    }
    
    this.update.emit(this.editticket);
  }

  setRed(){
    this.stopLightNumber = 1; 
    this.editticket.triage = 1;
  }
  setYellow(){
    this.stopLightNumber = 2;
    this.editticket.triage = 2;
  }
  setGreen(){
    this.stopLightNumber = 3;
    this.editticket.triage = 3; 
  }

  getclass1(n){
    
    if(n==this.stopLightNumber){

        return 'redselect'
      
    }else{
      return "bulb red"
    }
  }


  getclass2(n){
    
    if(n==this.stopLightNumber){

        return 'yellowselect'
      
    }else{
      return "bulb yellow"
    }
  }


  getclass3(n){
    
    if(n==this.stopLightNumber){

        return 'greenselect'
      
    }else{
      return "bulb green"
    }
  }




  onSelectState(state_id){

    if (state_id) {
      const filter = {'state_id': state_id};
      this.api.statedistricts.get().filter(filter).promise()
        .then(d => {
          this.statesDistrict = d.data;
        });
    } else {
      this.statesDistrict = [];
    }

  }

}
